export function Menu() {
    const BODY = $("body");
    const WIN = $(window);
    const DOC = $(document);
    const point = 1200;
    const header = $(".header");
    const $menu = $(".navigation");
    const $menuTop = $menu.find(".navigation-top");
    const $submenu = $menu.find(".submenu");
    const $openSubmenu = $submenu.children("a");
    const $burger = $menu.find(".burger");
    const $menuAnchor = $menu.find(".menu-item a");
    const $ButtonAnchor = BODY.find(".is-anchor");
    const $banner = $(".call-us");
    let menuHeight = 0;
    let isMobile = false;
    let isScroll = false;
    const isLanding = Boolean($(".landing-page").length);
    initMenu();
    function initMenu() {
        let scroll = WIN.scrollTop();
        controlScroll(scroll);
        checkIsMobile();
        getMenuHeight();
        setEvents();
    }
    function switchMenuItems(scrolled) {
        $menuAnchor.each(function () {

            const $menuItem = $(this).parent();
            const idSection = $(this).attr("href").split("#").pop();
            const section = $(`#${idSection}`)
            if (!section.length) return;
            const sectionTop = section.offset().top;
            const sectionBottom = sectionTop + section.innerHeight();
            if (sectionTop < scrolled && scrolled < sectionBottom) {
                $menuAnchor.parent().removeClass("active");
                $menuItem.addClass("active");

                return;
            } else {
                $menuItem.removeClass("active");
            }
        });
        return;
    }
    function checkIsMobile() {
        isMobile = (WIN.outerWidth() <= point) ? true : false;
    }
    function getMenuHeight() {
        if (isMobile) {
            menuHeight = $menuTop.find(".top-menu").height();
        } else {
            menuHeight = $menu.height();
        }
    }
    function setEvents() {

        WIN.on("scroll", function () {
            let scroll = $(this).scrollTop();
            controlScroll(scroll);
            if (!isLanding || isScroll) return;
            let scrollCenter = scroll + WIN.innerHeight() / 2;
            if ($menuAnchor.length) switchMenuItems(scrollCenter);
        });
        $menuAnchor.on("click", function (e) {
            if (!isLanding) return;
            e.preventDefault();
            isScroll = true;
            if (isMobile) {
                BODY.removeClass("menu-opened");
            }
            $(".menu-item").removeClass("active");
            $(this).parent().addClass("active");
            let idSection = $(this).attr("href").split("#").pop();
            scrollToSection(idSection);

        });
        $ButtonAnchor.on("click", function (e) {
            const $anchor = $(this);
            if (!BODY.hasClass("no-touch")) return;
            e.preventDefault();
            let idSection = $(this).attr("data-href").split("#").pop();
            scrollToSection(idSection);
        });
        $burger.on("click", function () {
            if (BODY.hasClass("menu-opened")) {
                BODY.removeClass("menu-opened");
                if (!BODY.hasClass("scrolled")) {
                    $menuTop.removeAttr("style");
                }
            } else {
                hideBaner();
                BODY.addClass("menu-opened");
            }
        });
        $openSubmenu.on("click", function (e) {
            e.preventDefault();
            $submenu.toggleClass("active");
        });
        WIN.on("resize", function () {
            checkIsMobile();
            if (WIN.innerWidth() >= point) {
                BODY.removeClass("menu-opened");
            }
            getMenuHeight();
        });
        DOC.on("click", function (e) {
            if ($(e.target).closest(".lang-active").length) return;
            $submenu.removeClass("active");
        });
    }
    function scrollToSection(idSection) {
        let section = $(`#${idSection}`)
        if (!section.length) return
        $("html, body").animate({
            scrollTop: $(`#${idSection}`).offset().top - menuHeight
        }, 700, () => isScroll = false);
    }
    function controlScroll(scroll) {

        if (scroll > 0) {
            BODY.addClass("scrolled");
            hideBaner();
        } else {
            BODY.removeClass("scrolled");
            $menuTop.removeAttr("style");
        }
    }
    function hideBaner() {
        if (isMobile && $banner.length) {
            const value = $banner.height();
            $menuTop.css("transform", `translateY(-${value}px)`);
        }
    }


}


// WEBPACK FOOTER //
// ./assets/js/modules/Menu.js